module.exports = __webpack_public_path__ + "img/auto-optimize.b9a9c353.svg";